// src/components/PageHeader.jsx
import React from 'react';
import './PageHeader.css';

const PageHeader = ({ title, subtitle }) => {
  return (
    <div className="page-header">
      <h1 className="page-header-title">{title}</h1>
      {subtitle && <h2 className="page-header-subtitle">{subtitle}</h2>}
    </div>
  );
};

export default PageHeader;
